// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","Pomegranate":"#FF0032","Blueberry":"#3E3AC2","intro":"Ge06a79","main":"G1c37a5","text":"G3e5dbc"};